import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import Asset from './AssetRowComponent';

// eslint-disable-next-line react/display-name
const AssetListComponent = React.memo(({
    assets,
    powertrainId,
    limitSummary,
    selectedAsset,
    allAssets,
    handleSelectedItem,
    handleAssetToggle,
    showThreshold,
    showTrend,
    isHorizontalScrollActive,
    memoizedPowertrainOverviewList,
    selectedPowertrain,
    translate,
    isLabelVisible,
    leftPanelSize
}) => {
    const memoizedAssets = useMemo(() => assets, [assets]);
    const memoizedRenderAssets = useMemo(() => {
        return map(memoizedAssets, (asset) =>
            <Asset
                key={asset?.assetId}
                asset={asset}
                limitSummary={limitSummary}
                selectedAsset={selectedAsset}
                allAssets={allAssets}
                onSelectedItem={handleSelectedItem}
                onAssetToggle={handleAssetToggle}
                showThreshold={showThreshold}
                showTrend={showTrend}
                isHorizontalScrollActive={isHorizontalScrollActive}
                powertrainList={memoizedPowertrainOverviewList}
                selectedPowertrain={selectedPowertrain}
                isLabelVisible={isLabelVisible}
                leftPanelSize={leftPanelSize}
            />
        );
    }, [memoizedAssets, selectedAsset]);
    return (
        <>
            {!memoizedAssets || memoizedAssets.length === 0 ?
                <div className='no-available-assets'>
                    {translate('ABB.Powertrain.Frontend.conditionIndicesOverviewNoAvailableAssets')}
                </div>
                :
                <div key={powertrainId} className='asset-list-of-asset-group'>
                    {memoizedRenderAssets}
                </div>
            }
        </>
    );
});

AssetListComponent.propTypes = {
    assets: PropTypes.array.isRequired,
    powertrainId: PropTypes.number.isRequired,
    limitSummary: PropTypes.object,
    selectedAsset: PropTypes.object,
    allAssets: PropTypes.array,
    handleSelectedItem: PropTypes.func.isRequired,
    handleAssetToggle: PropTypes.func.isRequired,
    showThreshold: PropTypes.bool,
    showTrend: PropTypes.bool,
    isHorizontalScrollActive: PropTypes.bool,
    memoizedPowertrainOverviewList: PropTypes.array,
    selectedPowertrain: PropTypes.number,
    translate: PropTypes.func.isRequired,
    leftPanelSize: PropTypes.number,
};

// eslint-disable-next-line import/no-unused-modules
export default AssetListComponent;
